import { MODAL_EVENT } from "@client.components/Modal";
import ServiceProvider from "@client.services/provider";
import { useCallback } from "react";

const useModal = () => {
  const showModal = useCallback(
    ({ title, component, onClose, contentClass, footerButtons }) => {
      const buttonSettings = footerButtons?.length
        ? footerButtons.map((btn) => ({
            ...btn,
            text: btn.text || title,
            onClick: async () => {
              return btn.onClick().then((resp) => {
                if (!resp.error) {
                  ServiceProvider.EventEmitter.emit(MODAL_EVENT, {
                    show: false,
                  });
                }
              });
            },
          }))
        : null;

      ServiceProvider.EventEmitter.emit(MODAL_EVENT, {
        show: true,
        withBodyRef: false,
        component: component,
        title: title,
        contentClass,
        onClose: onClose,
        buttonSettings,
      });
    },
    []
  );

  const showFormModal = useCallback(
    ({ title, component, onClose, contentClass, footerButtons }) => {
      const buttonSettings = footerButtons.map((btn) => ({
        ...btn,
        text: btn.text || title,
        onClick: async (component) => {
          const isValid = component.validate();

          return isValid
            ? btn.onClick(component.managementItem).then((resp) => {
                if (resp.error) return;

                if (btn.onSuccess) {
                  btn.onSuccess(component.managementItem);
                } else {
                  ServiceProvider.EventEmitter.emit(MODAL_EVENT, {
                    show: false,
                  });
                }
              })
            : Promise.resolve();
        },
      }));

      ServiceProvider.EventEmitter.emit(MODAL_EVENT, {
        show: true,
        withBodyRef: true,
        component,
        title,
        onClose,
        contentClass,
        buttonSettings,
      });
    },
    []
  );

  return { showFormModal, showModal };
};

export default useModal;
